import React from 'react';
import { bool, shape, string } from 'prop-types';

const WarningColor = ({
  className = 'icon',
  color = '#696f88',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 4.4925L14.6475 14.25H3.3525L9 4.4925ZM9 1.5L0.75 15.75H17.25L9 1.5ZM9.75 12H8.25V13.5H9.75V12ZM9.75 7.5H8.25V10.5H9.75V7.5Z" fill="currentColor" />
  </svg>
);

WarningColor.propTypes = {
  className: string,
  color: string,
  notUseClass: bool,
  style: shape({}),
};

export default WarningColor;
